module.exports = __webpack_public_path__ + "static/media/OnlExp.fa555921.jpg";